import PropTypes from 'prop-types';

export default {
    binderId: PropTypes.string.isRequired,
    users: PropTypes.objectOf(PropTypes.shape({
        sub: PropTypes.string,
        displayName: PropTypes.string,
        emailAddress: PropTypes.string,
        groups: PropTypes.arrayOf(PropTypes.string),
        binderPermissions: PropTypes.objectOf(PropTypes.shape({
            name: PropTypes.string,
            isRestricted: PropTypes.bool,
            value: PropTypes.string
        }))
    })),
    groups: PropTypes.objectOf(PropTypes.shape({
        id: PropTypes.string,
        displayName: PropTypes.string,
        description: PropTypes.string
    })),
    permissionProperties: PropTypes.objectOf(PropTypes.shape({
        name: PropTypes.string,
        displayName: PropTypes.string,
        value: PropTypes.string,
        allowedValues: PropTypes.arrayOf(PropTypes.string)
    })),
    searchString: PropTypes.string,
    viewAllUsers: PropTypes.oneOf(['all', 'in', 'out']).isRequired,
    viewSummaryMode: PropTypes.bool.isRequired,
    permissionsDelta: PropTypes.object.isRequired,
    unsavedChanges: PropTypes.bool.isRequired,
    isSaving: PropTypes.bool.isRequired,
    visibleUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
    sortedUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
    selectedUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
    updatedUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
    changeSelection: PropTypes.func.isRequired,
    changeSearch: PropTypes.func.isRequired,
    toggleUserPermissionsEditorSetting: PropTypes.func.isRequired,
    changePermissionsDelta: PropTypes.func.isRequired,
    grantAccess: PropTypes.func.isRequired,
    revokeAccess: PropTypes.func.isRequired,
    initializeUserPermissionsEditor: PropTypes.func.isRequired,
    loadUsersConfiguration: PropTypes.func.isRequired,
    saveChanges: PropTypes.func.isRequired,
    addApplicationMessage: PropTypes.func.isRequired,
    mergeBinderUsers: PropTypes.func.isRequired,

};